$(function () {
    $('.js-open-tab').on('click', function(){
        $('.tab--opened-position').toggleClass('visible-print')
        $('.tab-arrow img').toggleClass('open-tab-arrow')
    })
});